import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Collapse } from 'antd';

interface ReportBreakdownProps<T> {
  data: T[];
  title: string;
  renderLeft: (item: T) => React.ReactNode;
  renderRight: (item: T) => React.ReactNode;
  renderItem: (item: T) => React.ReactNode;
}

export function ReportBreakDown<T extends { id: string }>(props: ReportBreakdownProps<T>) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  const onToggleAllClick = () => {
    if (isCollapsed) {
      setActiveKeys(props.data.map((i) => i.id) ?? []);
    } else {
      setActiveKeys([]);
    }
    setIsCollapsed(!isCollapsed);
  };

  const onPanelClick = (key: string | string[]) => {
    if (key instanceof Array) {
      setActiveKeys(Array.from(key));
    } else {
      setActiveKeys([key]);
    }
  };

  const renderCollapseButton = () => {
    return (
      <Button className="no-print" type="link" onClick={onToggleAllClick}>
        {isCollapsed ? 'expand all' : 'collapse all'}
      </Button>
    );
  };

  useEffect(() => {
    if (activeKeys.length === props.data.length && isCollapsed) {
      setIsCollapsed(false);
    } else if (activeKeys.length === 0 && !isCollapsed) {
      setIsCollapsed(true);
    }
  }, [activeKeys]);

  return (
    <>
      <div className="modal-display" style={{ marginTop: '15px', backgroundColor: '#fff', border: '1px solid #d9d9d9', borderRadius: '15px', padding: '10px' }}>
        <Row justify="space-between" style={{ fontWeight: 'bold' }}>
          <Col>{props.title}</Col>
          <Col>{renderCollapseButton()}</Col>
        </Row>
        <Collapse className="report" bordered={false} activeKey={activeKeys} onChange={onPanelClick}>
          {props.data.map((item) => {
            return (
              <Collapse.Panel
                key={item.id}
                header={
                  <Row justify="space-between">
                    <Col>
                      <span style={{ marginLeft: '5px' }}>{props.renderLeft(item)}</span>
                    </Col>
                    <Col>
                      <span style={{ textAlign: 'right' }}>{props.renderRight(item)}</span>
                    </Col>
                  </Row>
                }
              >
                {props.renderItem(item)}
              </Collapse.Panel>
            );
          })}
        </Collapse>
        <Row justify="end">
          <Col></Col>
          <Col>{renderCollapseButton()}</Col>
        </Row>
      </div>
    </>
  );
}
